/* eslint-disable import/no-anonymous-default-export */
import * as React from "react";
import {
  FilterList,
  FilterLiveSearch,
  FilterListItem,
  useGetIdentity,
  useGetList,
} from "react-admin";
import { Box } from "@mui/material";
import EventIcon from "@mui/icons-material/Event";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";

import { DIAS_SEMANA } from "./diasSemana";

export const SupplierListFilter = () => {
  const { identity } = useGetIdentity();

  const { data: buyers } = useGetList("buyers", {
    pagination: { page: 1, perPage: 500 },
    sort: { field: "nome_razao", order: "ASC" },
  });
  return (
    <Box width="13em" minWidth="13em" order={-1} mr={2} mt={5}>
      <FilterLiveSearch hiddenLabel />

      <FilterList label="Comprador" icon={<SupervisorAccountIcon />}>
        <FilterListItem
          label="Eu"
          value={{
            id_comprador: identity?.id,
          }}
        />
        {buyers &&
          buyers.map((buyer) => (
            <FilterListItem
              key={buyer.id}
              label={buyer.nome_comprador}
              value={{ id_comprador: buyer.id }}
            />
          ))}
      </FilterList>

      <FilterList label="Dia da semana" icon={<EventIcon />}>
        {DIAS_SEMANA.map((dia) => (
          <FilterListItem
            key={dia.id}
            label={dia.name}
            value={{ dia_semana_iso: dia.id }}
          />
        ))}
      </FilterList>
    </Box>
  );
};
